import React from 'react';

export interface AvatarCompProps { src: string; imageClass: string; useSpriteSheet: boolean}

const AvatarComp = React.memo(function AvatarComp(props: AvatarCompProps) {
    const imageClass = props.imageClass || 'fitProfileImage roundFramePhoto';
    return (
        <div className='avatarcomp'>
            {props.useSpriteSheet ? 
                <span style={{marginLeft:'-12px'}}><i className="icon icon-outline-people-24px"></i></span> :
                <img
                    width="25"
                    height="25"
                    className={imageClass}
                    src={props.src}
                    alt=""
                />
            }            
        </div>
    );
});

export default AvatarComp;